import React from 'react';
import { css, cx } from 'emotion';
import PropTypes from 'prop-types';
export const withVariants = (WrappedComponent, variantsMap) => props => {
	return (
		<WrappedComponent
			{...props}
			variantWrapperStyle={mergeWithVariantsMap(
				WrappedComponent.getWrapper(props),
				WrappedComponent.variants,
				variantsMap
			)}
		/>
	);
};

withVariants.propTypes = {
	component: PropTypes.Component,
	variantsMap: PropTypes.any,
};

const mergeWithVariantsMap = (className, variants, variantsMap) => {
	return cx(
		className,
		typeof variantsMap === 'object'
			? css(
					Object.assign(
						...Object.keys(variantsMap)
							.sort()
							.map(v => {
								return {
									[`@media (${v})`]: variants[variantsMap[v]],
								};
							})
					)
			  )
			: variants[variantsMap]
	);
};



// WEBPACK FOOTER //
// ./src/managers/componentManager.js